import { getPageCodeFilePath } from '../code/utils/veloUtils.js';
import { readWml, getPageId } from '../document/utils/wmlUtils.js';
import { applyDeleteCode, applyUpdateCode } from '../code/fsUpdates.js';
import { applyDocumentUpdate } from '../document/fsUpdates.js';
const applyDeletePage = (siteFsUpdate, pageId) => {
    siteFsUpdate.document = applyDocumentUpdate(siteFsUpdate.document, pageId, null);
    const veloPath = getPageCodeFilePath(pageId);
    siteFsUpdate.code = applyDeleteCode(siteFsUpdate.code, veloPath);
    return siteFsUpdate;
};
const applyCodeUpdateInPage = async (state, siteFsUpdate, pageId, path) => {
    siteFsUpdate.code = applyUpdateCode(siteFsUpdate.code, {
        path: getPageCodeFilePath(pageId),
        content: await state.fileSystem.readFile(path)
    });
    return siteFsUpdate;
};
export const accumulatePageFsUpdateToWixSiteFSUpdate = async (state, siteFsUpdate, structureInfo, { action, path }) => {
    const result = siteFsUpdate;
    const pageId = state.pages.getPageId(structureInfo.pagePath);
    if (action === 'DELETE') {
        if (!pageId) {
            // page already removed
            return result;
        }
        const { document, code } = applyDeletePage(result, pageId);
        result.document = document;
        result.code = code;
        state.pages.removePageById(pageId);
    }
    else if (action === 'UPDATE') {
        const page = state.fileStructure.getPageFilesPaths(structureInfo.pagePath);
        if (structureInfo.type === 'document') {
            const wml = await readWml(state.fileSystem, page.document);
            const pageIdInDocument = await getPageId(state.fileSystem, page.document);
            const folderPathForPageIdInDocument = state.pages.getFolderPath(pageIdInDocument);
            // pageIdInDocument is reffering to existing page, which is not equal to the current one
            if (folderPathForPageIdInDocument && folderPathForPageIdInDocument !== structureInfo.pagePath) {
                throw new Error(`Duplicated pageId found in structure.xml files: ${pageIdInDocument}`);
            }
            // if pageId not equal, then we or add new page or change id in structure
            if (pageId !== pageIdInDocument) {
                if (pageId) {
                    const { document, code } = applyDeletePage(result, pageId);
                    result.document = document;
                    result.code = code;
                    await applyCodeUpdateInPage(state, result, pageIdInDocument, page.code);
                    state.pages.removePageById(pageId);
                }
                state.pages.addPage(pageIdInDocument, structureInfo.pagePath);
            }
            result.document = applyDocumentUpdate(result.document, pageIdInDocument, { data: wml });
        }
        else if (structureInfo.type === 'code') {
            if (!pageId) {
                // no pageId for this code file, so just skip it
                return result;
            }
            await applyCodeUpdateInPage(state, result, pageId, path);
        }
    }
    return result;
};
